const propelInit = function() {
const tabLocationsListBlocks = document.querySelectorAll(
	'.block-tab-locations-list'
);

tabLocationsListBlocks.forEach((tabLocationsListBlock) => {
	const toggleFilter = (e) => {
		const currentButton = e.currentTarget;
		const selectedArea = currentButton.dataset.area;

		filterButtons.forEach((filterButton) => {
			filterButton.setAttribute(
				'aria-current',
				filterButton === currentButton ? 'true' : 'false'
			);
		});

		areas.forEach((area) => {
			area.classList.toggle(
				'is-hidden',
				'' !== selectedArea && area.dataset.area !== selectedArea
			);
		});

		images.forEach((image) => {
			image.classList.toggle(
				'is-active',
				image.dataset.area === selectedArea
			);
		});
	};

	const filterButtons = tabLocationsListBlock.querySelectorAll(
		'.block-tab-locations-list__filter-button'
	);

	const areas = tabLocationsListBlock.querySelectorAll(
		'.block-tab-locations-area'
	);

	const images = tabLocationsListBlock.querySelectorAll(
		'.block-tab-locations-list__image'
	);

	filterButtons.forEach((filterButton) => {
		filterButton.addEventListener('click', toggleFilter);
	});
});

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['tab-locations-list'] = window.propel.blocks['tab-locations-list'] || {};
window.propel.blocks['tab-locations-list'].script = propelInit;
